import strings from 'strings';
import {
  ApplicantEntity,
  CandidateEntity,
  ContactEntity,
  JobOrderEntity
} from 'UI/constants/entityTypes';

export const ORDER_BY_OPTIONS = { column: 'score', direction: 'desc' };

export const MILLISECONDS_INTERVAL =
  parseInt(process.env.REACT_APP_MATCH_MAKING_POLLING_FREQUENCY, 10) || 3000;

export const RESPONSE_STATUSES = {
  completed: 'Completed',
  failed: 'Failed',
  running: 'Running'
};

export const MatchedQueryParamMap = {
  [ApplicantEntity.singular]: 'matchedJobOrder',
  [CandidateEntity.singular]: 'matchedJobOrder',
  [ContactEntity.singular]: 'matchedCandidate',
  [JobOrderEntity.singular]: 'matchedCandidate'
};

export const MATCH_MODES = {
  default: 'default',
  aiMatch: 'aiMatch'
};

export const COPIES = strings.inventory.matchMaking;
